export const enum ResourceType {
    ResourceGroup = 'Resource Group',
    Batch = 'Batch Account',
    BatchPool = 'Batch Account Pool',
    Storage = 'Storage Account',
    Function = 'Function App',
    Deployment = 'Resource Deployment',
    AzureDataLakeStore = 'Azure Data Lake Store'
}

export const enum ResourceLockType {
    DeleteLock = 'CanNotDelete',
    VNetDeleteLock = 'VNetDeleteLock',
    StaticPublicIPDeleteLock = 'StaticPublicIPDeleteLock'
}

export interface IResourcePathSegments {
    providerNamespace: string;
    resourceType: string;
    parentResourceType?: string;
    apiVersion: string;
}

export function getResourcePathSegments(resType: ResourceType): IResourcePathSegments {
    switch (resType) {
        case ResourceType.Batch:
            return {
                providerNamespace: 'Microsoft.Batch',
                resourceType: 'batchAccounts',
                apiVersion: '2017-09-01'
            };
        case ResourceType.BatchPool:
            return {
                providerNamespace: 'Microsoft.Batch',
                resourceType: 'pools',
                parentResourceType: 'batchAccounts',
                apiVersion: '2017-09-01'
            };
        case ResourceType.Storage:
            return {
                providerNamespace: 'Microsoft.Storage',
                resourceType: 'storageAccounts',
                apiVersion: '2018-02-01'
            };
        case ResourceType.Function:
            return {
                providerNamespace: 'Microsoft.Web',
                resourceType: 'sites',
                apiVersion: '2018-02-01'
            };
        case ResourceType.Deployment:
            return {
                providerNamespace: 'Microsoft.Resources',
                resourceType: 'deployments',
                apiVersion: '2024-03-01'
            };
        default:
            throw new Error(`${resType} is an unknown ResourceType`);
    }
}

export function getResourceUrlFormat(resType: ResourceType): string[] {
    switch (resType) {
        case ResourceType.Batch:
            return ['https://{0}.{1}.batch.azure.com'];
        case ResourceType.AzureDataLakeStore:
            return ['adl://{0}.azuredatalakestore.net', 'https://{0}.azuredatalakestore.net/webhdfs/v1'];
        default:
            throw new Error(`${resType} is an unknown ResourceType`);
    }
}
